// Copyright (C) 2019-2021 Intel Corporation
//
// SPDX-License-Identifier: MIT

module.exports = {
    backendAPI: '/api/v1',
    proxy: false,
};
